import {ChangeDetectorRef, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {countries} from "../../../../common";
import {FintechService} from "../../../../services/fintech.service";

export class FintechAddComponent {
    payMethodInfo: any = {};

    billForm: FormGroup;
    country;
    messageColor;
    billMessage;

    cardInfoChanged = true;

    m_countries = countries;




    constructor(protected fintechService: FintechService,
                protected http: HttpClient,
                protected formBuilder: FormBuilder,
                protected changeDetectorRef: ChangeDetectorRef) {
        this.billForm = this.formBuilder.group({
            cardholder: ['', [Validators.required, Validators.minLength(2)]],
            address1: ['', [Validators.required, Validators.minLength(2)]],
            address2: [''],
            city: ['', [Validators.required, Validators.minLength(2)]],
            state: [''],
            postalCode: ['', [Validators.required, Validators.minLength(2)]],
            country: ['', [Validators.required, Validators.minLength(2)]]
        });

        this.fintechService.busy$.subscribe( busy => {
            if (busy) {
                this.billForm.disable();
            } else {
                this.billForm.enable();
            }
        });
    }


    onCountry(country) {
        this.payMethodInfo.country =  this.billForm.value.country;
    }


    canSubmitBilling() {
        return !this.fintechService.busy && this.cardInfoChanged && this.billForm.valid;
    }









}
